import script from "./kevinHome.vue?vue&type=script&setup=true&lang=js"
export * from "./kevinHome.vue?vue&type=script&setup=true&lang=js"

import "./kevinHome.vue?vue&type=style&index=0&id=2d6a4362&lang=css"

const __exports__ = script;

export default __exports__